import NotFooterLayout from "layouts/NotFooterLayout";
import OrderCard from "components/OrderManage";
import { useSearchParams, useParams } from "react-router-dom";

function OrderPage({ order_id: orderIdProp }: { order_id?: string }) {
  //  const dispatch = useAppDispatch();

  const { order_id: orderIdFromParams } = useParams<{ order_id?: string }>();
  const [searchParams] = useSearchParams();
  const orderIdFromQuery = searchParams.get("order_id") ?? "";

  // รองรับทั้ง prop, path /order/:order_id, และ query string ?order_id=xxx
  const order_id = orderIdProp ?? orderIdFromParams ?? orderIdFromQuery ?? "";

  //show footer
  // dispatch(setFooterShow(true));
  return (
    <>
      {/* footerComponent={<FooterCreateOrder />} */}
      <NotFooterLayout namePage="คำสั่งซื้อ"  >
        <div className="layout-content">
          <OrderCard order_id={order_id || ""} />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default OrderPage;
